import * as React from "react";

export const MessageAndContent: React.FC<{
  data: {
    message?: string;
    internalComment?: string;
  };
}> = ({ data }) => (
  <>
    {data.message && (
      <article
        className="media notification has-text-weight-normal mt-3 is-size-7 pl-3 pr-3 pt-4 pb-4"
        style={{
          maxWidth: "800px",
        }}
      >
        <div className="media-content">
          <div className="content">
            <p className="has-text-weight-bold">申請者へのメッセージ</p>
            <p>
              {data.message &&
                data.message.split(`\n`).map((s) => (
                  <>
                    {s}
                    <br />
                  </>
                ))}
            </p>
          </div>
        </div>
      </article>
    )}
    {data.internalComment && (
      <article
        className="media notification has-text-weight-normal mt-3 is-size-7 pl-3 pr-3 pt-4 pb-4"
        style={{
          maxWidth: "800px",
        }}
      >
        <div className="media-content">
          <div className="content">
            <p className="has-text-weight-bold">内部コメント</p>
            <p>
              {data.internalComment.split(`\n`).map((s) => (
                <>
                  {s}
                  <br />
                </>
              ))}
            </p>
          </div>
        </div>
      </article>
    )}
  </>
);
